import { addLabels, isActive } from "../../../exports/apm";
import { getBodyElement } from "../../../exports/dom";
import { toggle } from "../../../exports/toggle";

/**
 *
 *
 */
export async function trackLegacySelectors(): Promise<void> {
  if (!(await isActive())) return;

  if (!toggle.get("gr_track_legacy_pali_selectors", false)) return;

  const nodes = Array.from(getBodyElement().querySelectorAll("*"));

  const prefixKey = "legacy-pattern-count_";
  const keyPTotal = `${prefixKey}p_total`;
  const keyPlTotal = `${prefixKey}pl_total`;

  const startsWithSelectors = [
    "pl_",
    "p_",
    "js_openTooltip",
    "js_openInPaliSheet",
    "js_openInPaliLayer",
    "js_openInPopup",
    "js_hasPaliTooltip",
  ];
  const legacyCounts = Array.from(nodes)
    .flatMap((el) =>
      Array.from(el.classList).filter(
        (c) =>
          !c.includes("__") &&
          !c.includes("--") &&
          startsWithSelectors.find((s) => c.startsWith(s)),
      ),
    )
    .reduce<Record<string, number>>((acc, name) => {
      const key = `${prefixKey}${name}`;
      acc[key] = (acc[key] || 0) + 1;
      if (name.startsWith("p_")) acc[keyPTotal] = (acc[keyPTotal] || 0) + 1;
      if (name.startsWith("pl_")) acc[keyPlTotal] = (acc[keyPlTotal] || 0) + 1;
      return acc;
    }, {});

  addLabels({
    dom_nodes: nodes.length,
    ...legacyCounts,
  });
}
